import { Component, OnInit } from '@angular/core';
import { PopoverController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-historie-filter-popover',
  templateUrl: './historie-filter-popover.page.html',
  styleUrls: ['./historie-filter-popover.page.scss'],
})
export class HistorieFilterPopoverPage implements OnInit {

  public historieFilter: 'lfHeute' | 'lfGestern' | 'lfAlle' | 'beHeute' | 'beGestern' | 'beAlle' = 'lfHeute';

  constructor(public popoverCtrl: PopoverController, navParams: NavParams) {
    this.historieFilter = navParams.get('value');
  }

  ngOnInit() {
  }

  select(value) {
    this.popoverCtrl.dismiss({value: value});
  }
}
